import { useState, useCallback } from "react";
import axios from "axios";
import { leaseService } from "../../../../../../configs/constants";
export const useClearCheque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const clearCheque = useCallback(async ({ leaseId, pdcId, subPdc, isCleared = true }) => {
    setLoading(true);
    setError(null);

    try {
      const url = `${leaseService}/booking/clearCheque/${leaseId}/${pdcId}`;

      const data = { isCleared, ...(subPdc && { subPdc }) };
      const response = await axios.patch(url, data);

      return response.data;
    } catch (err) {
      setError(err);
      throw err;
   
    } finally {
      setLoading(false);
    }
  }, []);

  return { clearCheque, loading, error };
};
